export const assetChainModules = {
  assets: true,
};

export const assethubChainModules = {
  assets: true,
};
